export const baseFontSize = 16
export const pxToRem = (size: number, base = baseFontSize) => String(size / base + 'rem')
